import * as React from "react";
import styled from "styled-components";
import { useFormikContext } from "formik";
import { isTypeRelativeWithEnd } from "views/typeGuards/timeRange";
import { RELATIVE_ALL_TIME, DEFAULT_RELATIVE_FROM, DEFAULT_RELATIVE_TO } from "views/Constants";
import { Icon } from "components/common";
import {
  classifyToRange,
  classifyFromRange,
  RELATIVE_CLASSIFIED_ALL_TIME_RANGE
} from "./RelativeTimeRangeClassifiedHelper";
import RelativeRangeSelect from "./RelativeRangeSelect";
const RelativeWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-around;
`;
const StyledIcon = styled(Icon)`
  flex: 0.75;
`;
const TabRelativeTimeRange = ({ disabled = false, limitDuration = 0 }) => {
  const {
    values: { timeRangeTabs },
    setFieldValue
  } = useFormikContext();
  const activeTabTimeRange = timeRangeTabs.relative;
  const disableUntil = disabled || isTypeRelativeWithEnd(activeTabTimeRange) && activeTabTimeRange.from === RELATIVE_ALL_TIME;
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(RelativeWrapper, null, /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    RelativeRangeSelect,
    {
      defaultRange: classifyFromRange(DEFAULT_RELATIVE_FROM),
      disableUnsetRange: limitDuration !== 0,
      disabled,
      fieldName: "from",
      limitDuration,
      onUnsetRange: () => {
        setFieldValue("timeRangeTabs.relative.to", RELATIVE_CLASSIFIED_ALL_TIME_RANGE);
      },
      title: "From:",
      unsetRangeLabel: "All Time"
    }
  ), /* @__PURE__ */ React.createElement(StyledIcon, { name: "arrow_right_alt" }), /* @__PURE__ */ React.createElement(
    RelativeRangeSelect,
    {
      defaultRange: classifyToRange(DEFAULT_RELATIVE_TO),
      disableUnsetRange: disableUntil,
      disabled: disableUntil,
      fieldName: "to",
      limitDuration,
      title: "Until:",
      unsetRangeLabel: "Now"
    }
  ))));
};
export default TabRelativeTimeRange;
